// web/src/app/services/examen.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Examen } from '../models/examen.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ExamenService {
  private apiUrl = `${environment.apiUrl}/examenes`;

  constructor(private http: HttpClient) {}

  getExamenes(): Observable<Examen[]> {
    return this.http.get<any[]>(this.apiUrl).pipe(
      map(data => data.map(item => Examen.fromApiData(item)))
    );
  }

  getExamen(id: string): Observable<Examen> {
    return this.http.get<any>(`${this.apiUrl}/${id}`).pipe(
      map(data => Examen.fromApiData(data))
    );
  }

  getExamenesByEstudiante(nroLibreta: number): Observable<Examen[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/estudiantes/${nroLibreta}/examenes`).pipe(
      map(data => data.map(item => Examen.fromApiData(item)))
    );
  }

  addExamen(examen: Examen): Observable<Examen> {
    return this.http.post<any>(`${this.apiUrl}/registro`, examen.toJSON()).pipe(
      map(data => Examen.fromApiData(data))
    );
  }

  updateExamen(examen: Examen): Observable<Examen> {
    return this.http.put<any>(`${this.apiUrl}/${examen.id}/updt`, examen.toJSON()).pipe(
      map(data => Examen.fromApiData(data))
    );
  }
}